export const externalIdentityVerificationInitialValues = {
  inAll: {
    verificationAttributes: [],
  },
  inAny: {
    verificationAttributes: [],
  },
  notInAll: {
    verificationAttributes: [],
  },
};
